<div class="relative h-[280px]">
    <canvas baseChart [datasets]="chartDataSets()" [labels]="chartLabels()" [options]="chartOption" [type]="CHART_TYPE"></canvas>
</div>
